import React from "react";
import { withFormik, Form } from "formik";
import * as Yup from "yup";
import { Label, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import Select from "react-select";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const AddstudentsToClassForm = (props) => {
  const { values, errors, touched, isSubmitting, dismissModal } = props;

  const handleChange = (selected) => {
    values.selectedstudentIds = selected.map((t) => t.id);
  };

  const getFilteredStudents = () => {
    var students = [];
    values.students.forEach((s) => {
      if (values.existingStudents.findIndex((es) => es.id === s.id) === -1) {
        students.push(s);
      }
    });
    return students;
  };

  return (
    <div className="col-12 col-sm-12">
      <Form>
        <Label>
          <FormattedMessage id="ChooseOneOrMoreStudents" />
        </Label>
        <Select
          className={`${
            errors.selectedstudentIds &&
            touched.selectedstudentIds &&
            "is-invalid"
          }`}
          isMulti
          onChange={(selected) => handleChange(selected)}
          options={getFilteredStudents().map((option) => ({
            ...option,
            label: option.name,
            value: option.id,
            clearableValue: true,
          }))}
        />
        {errors.selectedstudentIds && touched.selectedstudentIds && (
          <div className="invalid-feedback">{errors.selectedstudentIds}</div>
        )}
        <div className="btn-container">
          <Button
            type="submit"
            className="btn btn-outline-primary float-start"
            disabled={isSubmitting}
          >
            <FormattedMessage id={isSubmitting ? "Wait" : "Add"} />
          </Button>
          <Button type="button" onClick={dismissModal} className="float-end">
            <FormattedMessage id="Cancel" />
          </Button>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    classId: props.classId,
    students: props.students,
    existingStudents: props.existingStudents,
    selectedStudentIds: [],
  }),

  validationSchema: Yup.object().shape({
    selectedStudentIds: Yup.array().min(
      1,
      <FormattedMessage id="Views.Admin.AddstudentToClassForm.Error.Selectstudents" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setSubmitting }) {
    axios
      .post(
        `/AddstudentsToClass?studentIds=${values.selectedstudentIds.join(
          "&studentIds="
        )}&classId=${props.classId}`
      )
      .then((response) => {
        toast.success(
          <FormattedMessage id="Views.Admin.AddstudentToClassForm.Error.Success" />,
          TOAST_CONFIG
        );
        props.loadstudents();
        resetForm();
      })
      .catch((err) => {
        toast.error(err.response.data, TOAST_CONFIG);
      });
    setSubmitting(false);
  },
})(AddstudentsToClassForm);

export default FormikForm;
